import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../../tailwind.config';

export const CrmActivityNote: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['white'], background = theme.colors['bright-sky-blue'] }) => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill={background}/>
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke={background}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.6665 15H21.6665V16.6667H11.6665V15ZM11.6665 18.3333H21.6665V20H11.6665V18.3333ZM24.9998 18.3333H23.3332V21.6667H19.9998V23.3333H23.3332V26.6667H24.9998V23.3333H28.3332V21.6667H24.9998V18.3333ZM18.3332 23.3333H11.6665V21.6667H18.3332V23.3333Z" fill={fill} />
    </svg>
  )
);
